import React, {FC} from 'react';

import {ConfigurableLayer} from './configurableLayer';
import {FullScreenError} from './error/fullScreenError';
import {MainContentWrapper} from './mainContentWrapper';
import {useUserDefinedSurveyConfig} from './userDefinedSurvey/userDefinedSurveyConfig';

/*
 * Components.
 */

export const PageNotFoundError: FC = () => {
  const {config} = useUserDefinedSurveyConfig(false);

  return (
    <ConfigurableLayer backgroundColor={config.primaryColor}>
      <MainContentWrapper>
        <FullScreenError
          description={
            <>
              <span role="img" aria-label="sad face">
                😢
              </span>{' '}
              No such route.
            </>
          }
        />
      </MainContentWrapper>
    </ConfigurableLayer>
  );
};
